/* DezynCart theme JavaScript - vanilla, no dependencies */
(function () {
  'use strict';
  var T = window.dcTheme || { routes: {}, strings: {} };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, opts) {
    var el = qs('#DcToast');
    if (!el) return;
    opts = opts || {};
    el.textContent = message;
    if (opts.link) {
      var a = document.createElement('a');
      a.href = opts.link; a.textContent = opts.linkText || '';
      el.appendChild(a);
    }
    el.classList.toggle('is-error', !!opts.error);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4500);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }
  function refreshCartCount() {
    return fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !(form.matches('[data-ajax-cart]') || form.matches('[data-product-form]'))) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'add') return; // let dynamic checkout buttons work natively
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();

    var btn = submitter;
    var original = btn.textContent;
    var errorBox = qs('[data-product-error]', form);
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    btn.disabled = true;
    btn.textContent = T.strings.adding;

    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || T.strings.error;
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
          toast(msg, { error: true });
        } else {
          toast(T.strings.added, { link: T.routes.cart, linkText: T.strings.viewCart });
          return refreshCartCount();
        }
      })
      .catch(function () { toast(T.strings.error, { error: true }); })
      .then(function () { btn.disabled = false; btn.textContent = original; });
  });

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = qs('input[type="number"]', wrap);
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var min = input.min === '' ? 1 : parseInt(input.min, 10);
    var max = input.max === '' ? Infinity : parseInt(input.max, 10);
    var val = parseInt(input.value, 10) || 0;
    val = plus ? val + step : val - step;
    val = Math.max(min, Math.min(max, val));
    var changed = String(val) !== input.value;
    input.value = val;
    if (changed && input.hasAttribute('data-cart-qty')) {
      input.form.submit();
    }
  });
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input.matches && input.matches('[data-cart-qty]')) {
      if (input.value === '' || parseInt(input.value, 10) < 0) input.value = 0;
      input.form.submit();
    }
  });
  // Cart remove links keep native behaviour (GET /cart/change?line=&quantity=0)

  /* ---------- Mobile drawer ---------- */
  var drawer = qs('[data-drawer]');
  var lastFocus;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    var opener = qs('[data-nav-open]'); if (opener) opener.setAttribute('aria-expanded', 'true');
    var closeBtn = qs('.dc-drawer__head button', drawer); if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    var opener = qs('[data-nav-open]'); if (opener) opener.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) openDrawer();
    else if (e.target.closest('[data-nav-close]')) closeDrawer();
  });

  /* ---------- Close All Categories on outside click / Escape ---------- */
  document.addEventListener('click', function (e) {
    qsa('[data-allcats][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeFilters();
    qsa('[data-allcats][open]').forEach(function (d) { d.removeAttribute('open'); });
    qsa('[data-predictive-results]').forEach(function (r) { r.hidden = true; });
  });

  /* ---------- Predictive search ---------- */
  qsa('[data-search-wrap]').forEach(function (wrap) {
    var input = qs('[data-predictive-input]', wrap);
    var results = qs('[data-predictive-results]', wrap);
    if (!input || !results || !T.routes.predictiveSearch) return;
    var controller;
    var run = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection&resources[limit]=5&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = source.innerHTML;
          results.hidden = false;
        })
        .catch(function (err) { if (err.name !== 'AbortError') results.hidden = true; });
    }, 250);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (results.innerHTML.trim()) results.hidden = false; });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) results.hidden = true; });
  });

  /* ---------- Collection filters ---------- */
  var filters = qs('[data-filters]');
  var overlay = qs('.dc-filters-overlay');
  function openFilters() { if (!filters) return; filters.classList.add('is-open'); if (overlay) overlay.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeFilters() { if (!filters) return; filters.classList.remove('is-open'); if (overlay) overlay.hidden = true; document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) openFilters();
    else if (e.target.closest('[data-filter-close]')) closeFilters();
  });
  var filterForm = qs('[data-filter-form]');
  if (filterForm) {
    var submitFilters = debounce(function () {
      var params = new URLSearchParams(new FormData(filterForm));
      qsa('input[type="number"]', filterForm).forEach(function (i) { if (i.value === '') params.delete(i.name); });
      window.location.search = params.toString();
    }, 400);
    filterForm.addEventListener('change', submitFilters);
  }
  var sortSelect = qs('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () { sortSelect.form.submit(); });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = qs('[data-product-json]', section);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = qs('[data-product-form]', section);
    var idInput = qs('[data-variant-id]', section);
    var addBtn = qs('[data-add-button]', section);
    var sectionId = section.getAttribute('data-section-id');
    var productUrl = section.getAttribute('data-product-url');
    var optionFieldsets = qsa('[data-option-index]', section);

    function selectedOptions() {
      return optionFieldsets.map(function (fs) {
        var checked = qs('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(options) {
      return product.variants.filter(function (v) {
        return options.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }
    function markUnavailable() {
      var current = selectedOptions();
      optionFieldsets.forEach(function (fs, index) {
        qsa('input', fs).forEach(function (input) {
          var test = current.slice(); test[index] = input.value;
          var variant = findVariant(test);
          input.classList.toggle('is-unavailable', !variant || !variant.available);
        });
      });
    }
    function setGallery(mediaId) {
      if (!mediaId) return;
      var item = qs('[data-media-id="' + mediaId + '"]', section);
      if (!item) return;
      qsa('.dc-gallery__item', section).forEach(function (el) { el.classList.toggle('is-active', el === item); });
      qsa('[data-thumb]', section).forEach(function (b) {
        var on = b.getAttribute('data-thumb') === String(mediaId);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function setButton(variant) {
      if (!addBtn) return;
      if (!variant) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; return; }
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
    }
    function swapFromServer(variantId) {
      var url = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['#Price-' + sectionId, '#Meta-' + sectionId].forEach(function (sel) {
          var src = qs(sel, doc), dest = qs(sel, section);
          if (src && dest) dest.innerHTML = src.innerHTML;
        });
      }).catch(function () {});
    }
    function onChange() {
      var options = selectedOptions();
      optionFieldsets.forEach(function (fs, i) {
        var label = qs('[data-option-selected]', fs);
        if (label) label.textContent = options[i] || '';
      });
      var variant = findVariant(options);
      markUnavailable();
      setButton(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', variant.id);
        history.replaceState({}, '', u.toString());
      }
      if (variant.featured_media && variant.featured_media.id) setGallery(variant.featured_media.id);
      swapFromServer(variant.id);
    }
    optionFieldsets.forEach(function (fs) { fs.addEventListener('change', onChange); });
    markUnavailable();

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) setGallery(thumb.getAttribute('data-thumb'));
    });

    var share = qs('[data-share]', section);
    if (share) share.addEventListener('click', function () {
      var data = { title: share.getAttribute('data-share-title'), url: share.getAttribute('data-share-url') };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { toast(share.getAttribute('data-copied')); }); }
    });
  }
  qsa('[data-product-section]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  qsa('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.querySelector('.dc-grid')) return;
    fetch(url).then(function (r) { if (!r.ok) throw new Error('recs'); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = qs('[data-recommendations]', doc);
      if (src && src.innerHTML.trim()) el.innerHTML = src.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Address delete confirmation ---------- */
  document.addEventListener('submit', function (e) {
    var msg = e.target.getAttribute && e.target.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) e.preventDefault();
  });

  /* ---------- Country select default (address form) ---------- */
  qsa('select[data-default]').forEach(function (s) {
    var d = s.getAttribute('data-default');
    if (d) { for (var i = 0; i < s.options.length; i++) { if (s.options[i].value === d) { s.selectedIndex = i; break; } } }
  });
})();
